import React from "react";
import AppHeader from "../components/AppHeader";
import AppFooter from "../components/AppFooter";
import Intro from "../components/Intro";
import { makeStyles } from '@material-ui/core/styles';
import backgroundImage from '../resources/images/background.jpg';
import { Typography, Grid } from "@material-ui/core";
import {about, aboutWhat} from "../content/AboutContent";

const useStyles = makeStyles((theme) => ({
    backgroundDiv: {
        height: "350px",
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "100%",
        backgroundColor: '#141415',
		backgroundPosition: 'center',
        marginBottom: '20px',
        position: "relative"
    },
    attributeText: {
        fontSize: '8px',
        position: "absolute",
        bottom: "10px",
        right: '0'
    },
    contentDiv: {
        position: "relative",
        width: '100%',
        margin: 'auto',
        paddingTop: '100px',
        textAlign: 'center'
    },
    primaryText: {
        color: 'white',
        marginTop: '15px',
        marginBottom: '15px',
    },
    container: {
        paddingLeft: '20px',
        paddingRight: '20px',
        width: '60%',
        [theme.breakpoints.down('xs')]: {
			width: '100% !important',
		},
        paddingTop: '30px',
        paddingBottom: '30px',
        marginBottom: '30px',
    },
    alignCenter: {
        display: 'flex',
        justifyContent: 'center'
    },
    background: {
        backgroundColor: '#eeeeee',
    },
    line: {
        border: 'none',
        borderTop:'5px solid  #2962ff',
        height:'5px',
        width:'10%',
    },
}));


function About() {
    const classes=useStyles();
    return (
        <div>
            <AppHeader appBarTitle="ELECTRONICS CLUB IIT GUWAHATI"/>
            <Intro primaryText="About Us" secondaryText="Who we are and What we do" pagename="About" classes={classes}/>
            <center>
                <Grid container className={classes.container}>
                    <Grid item xs = {12} className={classes.alignCenter}>
                        <Typography variant = "subtitle1">{about}</Typography>
                    </Grid>
                </Grid>
                <div className = {classes.background}>
                    <Grid container className={classes.container}>
                        <Grid item xs = {12} className={classes.alignCenter} >
                            <Typography variant = "h4">What we do ?</Typography>
                        </Grid>
                        <hr className={classes.line}></hr>
                        <Grid item xs = {12} className={classes.alignCenter} style = {{marginTop: '20px'}}> 
                            <Typography variant = "subtitle1">{aboutWhat}</Typography>
                        </Grid>
                    </Grid>
                </div>
            </center>
            
            <AppFooter />
        </div>
    )
}

export default About;